/**
 * Runtime domain values used after the raw CDEK response has crossed the
 * validation boundary. Keep provider strings out of business logic.
 */
export enum CdekShipmentDirection {
  Outbound = 'outbound',
  Return = 'return',
}

export enum CdekStatusCode {
  Delivered = 'DELIVERED',
  NotDelivered = 'NOT_DELIVERED',
  ReturnedToSender = 'RETURNED_TO_SENDER',
  ReturnedToClient = 'RETURNED_TO_CLIENT',
  ReturnedToSenderCityWarehouse = 'RETURNED_TO_SENDER_CITY_WAREHOUSE',
}

export enum CdekRelatedEntityType {
  ReturnOrder = 'return_order',
  ReverseOrder = 'reverse_order',
  DirectOrder = 'direct_order',
  Waybill = 'waybill',
  Barcode = 'barcode',
}

const RELATED_ENTITY_TYPES = new Set<string>(Object.values(CdekRelatedEntityType))
const RETURN_RELATED_ENTITY_TYPES = new Set<CdekRelatedEntityType>([
  CdekRelatedEntityType.ReturnOrder,
  CdekRelatedEntityType.ReverseOrder,
])

export function isCdekRelatedEntityType(value: unknown): value is CdekRelatedEntityType {
  return typeof value === 'string' && RELATED_ENTITY_TYPES.has(value)
}

export function isCdekReturnRelatedEntityType(
  value: CdekRelatedEntityType | undefined
): boolean {
  return value !== undefined && RETURN_RELATED_ENTITY_TYPES.has(value)
}
